import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getInOfficeHeadcountBasedQuantites, getFixedQuantities } from './utils';

export const filingcabinets = [
  {
    id: 72,
    name: 'spaceTypes.filingCabinets.36wideLateral',
    displayOrder: 1,
    spaceTypeId: spaceTypes.filingcabinets.id,
    size: {
      [countries.US]: getSize(3.0, 2.0),
      [countries.UK]: getSize(3.0, 2.0),
      [countries.FR]: getSize(1.6, 0.9),
      [countries.EU]: getSize(1.6, 0.9),
      [countries.DE]: getSize(1.6, 0.9),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(5, 5, 5),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(5, 5, 5),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(5, 5, 5),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(5, 5, 5),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818127/insite/qa/spaces/vfobljqqk3uqjnak5vkf.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818127/insite/qa/spaces/vfobljqqk3uqjnak5vkf.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818127/insite/qa/spaces/vfobljqqk3uqjnak5vkf.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818127/insite/qa/spaces/vfobljqqk3uqjnak5vkf.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818127/insite/qa/spaces/vfobljqqk3uqjnak5vkf.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 73,
    name: 'spaceTypes.filingCabinets.mobilePedestal',
    displayOrder: 2,
    spaceTypeId: spaceTypes.filingcabinets.id,
    size: {
      [countries.US]: getSize(3.0, 2.0),
      [countries.UK]: getSize(3.0, 2.0),
      [countries.FR]: getSize(0.6096, 0.9144),
      [countries.EU]: getSize(0.61, 0.91),
      [countries.DE]: getSize(0.61, 0.91),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818128/insite/qa/spaces/ftthegcrox4v2lkwjdgc.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818128/insite/qa/spaces/ftthegcrox4v2lkwjdgc.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818128/insite/qa/spaces/ftthegcrox4v2lkwjdgc.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818128/insite/qa/spaces/ftthegcrox4v2lkwjdgc.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818128/insite/qa/spaces/ftthegcrox4v2lkwjdgc.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
